
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/audiodescripcio",
      function () {
        return require("private-next-pages/corporatiu/atencio/audiodescripcio/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/audiodescripcio"])
      });
    }
  